export default "__VITE_ASSET__BQpzPYIB__"